import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Box, DataGrid, IconButton } from "../../../components";
import { filtrosUrl, PermisoesHelper, value } from "../../../helpers";
import { ListLayout } from "../../../layouts";
import {
  history,
  NfSaidaService,
  OperacaoFiscalService,
  PessoaService
} from "../../../services";
import { formatDate, formatPrice, responseErros } from "../../../utils";
import { NfSaida } from "../entities";
import {
  BaixarXmlDialog,
  DevolverMercadoriaDialog,
  DevolverMercadoriaFornecedorDialog,
  FormFiltroAvancado,
  ImportarCondicionalDialog,
  ImportarDocumentoDialog,
  ImportarOrcamentoDialog,
  ImportarOrdemServicoDialog,
  ImportarPedidoDialog,
  InutilizacaoDfeDialog,
  MenuSuperiorLista,
  NfeComplementarDialog,
} from "./components";
import NotaDebitoCreditoDialog from "./components/nota-debito-credito-dialog.component";
import { obterIconeStatus } from "./list-nf-saida";
const nfSaidaService = new NfSaidaService();
const operacaoFiscalService = new OperacaoFiscalService();
const pessoaService = new PessoaService();

const ListNfSaidaView = () => {
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("nf-saida-visualizar");
  const [loading, setLoading] = useState(false);
  const [nfsSaida, setNfsSaida] = useState([]);
  const [nfSaida, setNfSaida] = useState({});
  const [listaPessoas, setListaPessoas] = useState([]);
  const [linhasSelecionadas, setLinhasSelecionadas] = useState([]);
  const [listaOperacoesFiscais, setListaOperacoesFiscais] = useState([]);
  const [rowCount, setRowCount] = useState(null);
  const [documentoSelectionModel, setDocumentoSelectionModel] = useState([]);
  const [openImportarCondicionalDialog, setOpenImportarCondicionalDialog] =
    useState(false);
  const [openImportarOrcamentoDialog, setOpenImportarOrcamentoDialog] =
    useState(false);
  const [openImportarPedidoDialog, setOpenImportarPedidoDialog] =
    useState(false);
  const [openImportarOrdemServicoDialog, setOpenImportarOrdemServicoDialog] =
    useState(false);
  const [openDevolverMercadoriaDialog, setOpenDevolverMercadoriaDialog] =
    useState(false);
  const [openImportarDocumentoDialog, setOpenImportarDocumentoDialog] =
    useState(false);
  const [
    openDevolverMercadoriaFornecedorDialog,
    setOpenDevolverMercadoriaFornecedorDialog,
  ] = useState(false);
  const [filtrosDialog, setFiltrosDialog] = useState({});
  const [openNfeComplementarDialog, setOpenNfeComplementarDialog] =
    useState(false);
  const [openInutilizacaoDfeDialog, setOpenInutilizacaoDfeDialog] =
    useState(false);
  const [openBaixarXmlDialog, setOpenBaixarXmlDialog] = useState(false);
  const [openNotaDebitoCreditoDialog, setOpenNotaDebitoCreditoDialog] =
    useState(false);
  const status = [
    {
      nome: "ENVIADA",
      label: "Enviada",
      cor: "#4FBB53",
    },
    {
      nome: "FATURADA",
      label: "Faturada",
      cor: "#004780",
    },
    {
      nome: "PENDENTE",
      label: "Pendente",
      cor: "#EA9D2B",
    },
    {
      nome: "CANCELADA",
      label: "Cancelada",
      cor: "#DC3545",
    },
    {
      nome: "CONTINGENCIA",
      label: "Em Contingência",
      cor: "#BFBFBF",
    },
    {
      nome: "DENEGADA",
      label: "Denegada",
      cor: "#70309F",
    },
    {
      nome: "EM PROCESSAMENTO",
      label: "Em Processamento",
      cor: "#A0522D",
    },
    {
      nome: "INUTILIZADA",
      label: "Inutilizada",
      cor: "#e012a6",
    },
  ];

  const buttonSelectOpcoes = [
    { permission: true, descricao: "Importar Condicional" },
    { permission: true, descricao: "Importar Orçamento" },
    { permission: true, descricao: "Importar Pedido" },
    { permission: true, descricao: "Importar Documento" },
    { permission: true, descricao: "Importar Itens da O.S" },
    { permission: true, descricao: "Devolução de Mercadoria do Cliente" },
    { permission: true, descricao: "Devolução de Mercadoria ao Fornecedor" },
    { permission: true, descricao: "Documento de Transferência" },
    { permission: true, descricao: "NF-e Complementar" },
    { permission: true, descricao: "NF-e de Ajuste" },
    { permission: true, descricao: "Operação de Entrada" },
    { permission: true, descricao: "Inutilização de DF-e" },
    { permission: true, descricao: "Nota de Débito/Crédito" },
  ];

  const colunas = [
    {
      field: "status",
      headerName: "Status",
      sortable: true,
      align: "center",
      headerAlign: "center",
      flex: 50,
      renderCell: (params) => obterIconeStatus(params.value),
    },
    {
      field: "serieDocumento",
      headerName: "Série",
      align: "center",
      headerAlign: "center",
      width: 75,
      valueGetter: (params) => value.text(params.value),
    },
    {
      field: "numeroDocumento",
      headerName: "Nº Doc.",
      align: "center",
      headerAlign: "center",
      flex: 50,
      filtrar: true,
    },
    {
      field: "operacaoFiscalId",
      headerName: "Operação Fiscal",
      flex: 150,
      valueGetter: (params) =>
        listaOperacoesFiscais.find((item) => item.id == params.value)
          ?.descricao,
    },
    {
      field: "createdAt",
      headerName: "Emissão",
      align: "center",
      headerAlign: "center",
      width: 125,
      valueGetter: (params) =>
        format(formatDate.received(params.value), "dd/MM/yyyy"),
    },
    {
      field: "dataEmissao",
      headerName: "Autorização",
      align: "center",
      headerAlign: "center",
      width: 125,
      valueGetter: (params) =>
        params.row?.status == "ENVIADA" && params.value
          ? format(formatDate.received(params.value), "dd/MM/yyyy")
          : "",
    },
    {
      field: "clienteNome",
      headerName: "Cliente",
      width: 250,
      sortable: false,
      valueGetter: (params) =>
        params.value ??
        listaPessoas.find((item) => item.id == params.row.clienteId)
          ?.nomeRazaoSocial,
    },
    {
      field: "nfSaidaItens",
      headerName: "Valor Total",
      align: "right",
      headerAlign: "right",
      flex: 75,
      sortable: false,
      valueGetter: (params) => {
        const totalItensDespesasNfSaida =
          params.value
            .map((item) => item.subtotal)
            .reduce((acumulador, total) => acumulador + total, 0) -
          params.row.desconto +
          params.row.despesas +
          (params.row.subtotalTributosIncidentes || 0);
        const totalNfSaida = params.row.freteCompoeNota
          ? totalItensDespesasNfSaida + params.row.frete
          : totalItensDespesasNfSaida;
        return formatPrice(totalNfSaida);
      },
    },
  ];

  useEffect(() => {
    let filtros = filtrosUrl.get();
    if (filtros.status) {
      const status = filtros.status.split(",");
      buscarPesquisaAvancada({ ...filtros, status });
    } else {
      buscarNfSaida(filtros);
    }
  }, []);

  const buscarNfSaida = async function (filtro) {
    setLoading(true);
    const result = await nfSaidaService.getAll(filtro);
    if (!result.isAxiosError) {
      setNfsSaida(result.data.rows);
      setRowCount(result.data.count);
      buscarRelacionamentosNfsSaida(result.data.rows);
      filtrosUrl.set(filtro);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const buscarRelacionamentosNfsSaida = (listaDocumentos) => {
    const idsPessoas = [];
    const idsOperacoesFiscais = [];
    for (const objeto of listaDocumentos) {
      idsOperacoesFiscais.push(objeto.operacaoFiscalId);
      if (objeto.clienteId) idsPessoas.push(objeto.clienteId);
    }
    const idsUnicosOperacoesFiscais = [...new Set(idsOperacoesFiscais)];
    const idsUnicosPessoas = [...new Set(idsPessoas)];
    buscarOperacoesFiscais(idsUnicosOperacoesFiscais);
    buscarPessoas(idsUnicosPessoas);
  };

  const buscarOperacoesFiscais = (listaIds) => {
    const filtro = {
      id: listaIds.length > 0 ? listaIds : undefined,
      nonPaginated: true,
    };
    operacaoFiscalService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setListaOperacoesFiscais(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarPessoas = (listaIds) => {
    if (listaIds.length > 0) {
      const filtro = {
        id: listaIds,
        nonPaginated: true,
        disabledInclude: true,
        attributes: ["id", "nomeRazaoSocial"],
      };
      pessoaService.getAll(filtro).then((result) => {
        if (!result.isAxiosError) {
          const listaPessoas = result.data;
          setListaPessoas(listaPessoas);
        } else {
          responseErros(result);
        }
      });
    }
  };

  const onClickCadastrarNfSaida = function (descricao) {
    switch (descricao) {
      case "Importar Condicional":
        setOpenImportarCondicionalDialog(true);
        break;
      case "Importar Orçamento":
        setOpenImportarOrcamentoDialog(true);
        break;
      case "Importar Pedido":
        setOpenImportarPedidoDialog(true);
        break;
      case "Importar Itens da O.S":
        setOpenImportarOrdemServicoDialog(true);
        break;
      case "Importar Documento":
        setOpenImportarDocumentoDialog(true);
        break;
      case "Devolução de Mercadoria do Cliente":
        setOpenDevolverMercadoriaDialog(true);
        break;
      case "Devolução de Mercadoria ao Fornecedor":
        setOpenDevolverMercadoriaFornecedorDialog(true);
        break;
      case "Documento de Transferência":
        window.nfSaidaEntity = new NfSaida({
          transferencia: true,
        });
        history.push("/faturamento/nf-saida/transferencia");
        break;
      case "NF-e Complementar":
        setNfSaida({
          finalidade: "finalNfeComplementar",
        });
        setOpenNfeComplementarDialog(true);
        break;
      case "Inutilização de DF-e":
        setOpenInutilizacaoDfeDialog(true);
        break;
      case "NF-e de Ajuste":
        setNfSaida({
          finalidade: "finalNfeAjuste",
        });
        setOpenNfeComplementarDialog(true);
        break;
      case "Operação de Entrada":
        window.nfSaidaEntity = new NfSaida({
          operacaoEntrada: true,
        });
        history.push("/faturamento/nf-saida/operacao-entrada");
        break;
      case "Nota de Débito/Crédito":
        setOpenNotaDebitoCreditoDialog(true);
        break;
      default:
        history.push("/faturamento/nf-saida/create");
        break;
    }
  };

  const onClickEditNfSaida = function (id) {
    history.push(`/faturamento/nf-saida/${id}`);
  };

  const buscarPesquisaAvancada = async (filter) => {
    const porIntervalo = [];
    const filtrosAvancadosTemp = {
      ...filter,
    };
    if (
      filtrosAvancadosTemp.dataEmissaoStart &&
      filtrosAvancadosTemp.dataEmissaoEnd
    ) {
      porIntervalo.push({
        coluna: "dataEmissao",
        de: filtrosAvancadosTemp.dataEmissaoStart,
        ate: filtrosAvancadosTemp.dataEmissaoEnd,
      });
    }
    if (
      filtrosAvancadosTemp.dataLancamentoStart &&
      filtrosAvancadosTemp.dataLancamentoEnd
    ) {
      porIntervalo.push({
        coluna: "createdAt",
        de: filtrosAvancadosTemp.dataLancamentoStart,
        ate: filtrosAvancadosTemp.dataLancamentoEnd,
      });
    }
    if (filtrosAvancadosTemp.totalStart && filtrosAvancadosTemp.totalEnd) {
      porIntervalo.push({
        coluna: "totalVenda",
        de: parseFloat(filtrosAvancadosTemp.totalStart),
        ate: parseFloat(filtrosAvancadosTemp.totalEnd),
      });
    }
    delete filtrosAvancadosTemp.dataEmissaoStart;
    delete filtrosAvancadosTemp.dataEmissaoEnd;
    delete filtrosAvancadosTemp.dataLancamentoStart;
    delete filtrosAvancadosTemp.dataLancamentoEnd;
    delete filtrosAvancadosTemp.totalStart;
    delete filtrosAvancadosTemp.totalEnd;
    setLoading(true);
    const result = await nfSaidaService.getAllFiltroAvancado({
      ...filtrosAvancadosTemp,
      restritiva: true,
      porIntervalo,
    });
    if (!result.isAxiosError) {
      setNfsSaida(result.data.rows);
      setRowCount(result.data.count);
      buscarRelacionamentosNfsSaida(result.data.rows);
      filtrosUrl.set(filter);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const sendServerDatagrid = (props) => {
    if (props.tipoFiltro == "simples") {
      buscarNfSaida(props.filtros);
    } else {
      buscarPesquisaAvancada(props.filtros);
    }
  };

  const renderReloadAction = () => {
    const filtros = filtrosUrl.get();
    return (
      <Box sx={{ ml: 3 }}>
        <IconButton
          onClick={() => buscarNfSaida(filtros)}
          sx={{
            backgroundColor: "#EDEEF0",
            "&:hover": { backgroundColor: "#B6BABC" },
          }}
        >
          <i
            className="ph-fill ph-arrows-clockwise"
            style={{ fontSize: 22 }}
          ></i>
        </IconButton>
      </Box>
    );
  };

  return (
    <ListLayout
      title="Nf's de Saida"
      loading={loading}
      onClickCadastrar={onClickCadastrarNfSaida}
      buttonSelectOpcoes={buttonSelectOpcoes}
      permissaoButton={permissoesHelper.temPermisao("nf-saida-cadastrar")}
      ButtonMenu={
        <MenuSuperiorLista
          data={linhasSelecionadas}
          setOpenBaixarXmlDialog={setOpenBaixarXmlDialog}
        />
      }
    >
      <DataGrid
        checkboxSelection={true}
        onRowSelectionModelChange={(newRowSelectionModel) => {
          setLinhasSelecionadas(newRowSelectionModel);
        }}
        rows={nfsSaida}
        columns={colunas}
        onClickEdit={onClickEditNfSaida}
        visualizarShow={permissoesHelper.temPermisao("nf-entrada-visualizar")}
        editShow={permissoesHelper.temPermisao("nf-entrada-editar")}
        paginationMode={"server"}
        rowCount={rowCount}
        sendServer={sendServerDatagrid}
        FormFiltroAvancado={FormFiltroAvancado}
        extraActions={renderReloadAction()}
        listaStatus={status}
      />
      <ImportarOrcamentoDialog
        openImportarOrcamentoDialog={openImportarOrcamentoDialog}
        setOpenImportarOrcamentoDialog={setOpenImportarOrcamentoDialog}
        filtrosDialog={filtrosDialog}
        setFiltrosDialog={setFiltrosDialog}
      />
      <ImportarPedidoDialog
        openImportarPedidoDialog={openImportarPedidoDialog}
        setOpenImportarPedidoDialog={setOpenImportarPedidoDialog}
        filtrosDialog={filtrosDialog}
        setFiltrosDialog={setFiltrosDialog}
      />
      <ImportarOrdemServicoDialog
        openImportarOrdemServicoDialog={openImportarOrdemServicoDialog}
        setOpenImportarOrdemServicoDialog={setOpenImportarOrdemServicoDialog}
        filtrosDialog={filtrosDialog}
        setFiltrosDialog={setFiltrosDialog}
      />
      <ImportarDocumentoDialog
        openImportarDocumentoDialog={openImportarDocumentoDialog}
        setOpenImportarDocumentoDialog={setOpenImportarDocumentoDialog}
        filtrosDialog={filtrosDialog}
        setFiltrosDialog={setFiltrosDialog}
        buscarNfSaida={buscarNfSaida}
        buscarNfSaidaAvancado={buscarPesquisaAvancada}
        listaPessoas={listaPessoas}
        listaOperacoesFiscaisIniciais={listaOperacoesFiscais}
        setLoading={setLoading}
        documentoSelectionModel={documentoSelectionModel}
        setDocumentoSelectionModel={setDocumentoSelectionModel}
      />
      <DevolverMercadoriaDialog
        openDevolverMercadoriaDialog={openDevolverMercadoriaDialog}
        setOpenDevolverMercadoriaDialog={setOpenDevolverMercadoriaDialog}
        filtrosDialog={filtrosDialog}
        setFiltrosDialog={setFiltrosDialog}
        buscarNfSaida={buscarNfSaida}
        buscarNfSaidaAvancado={buscarPesquisaAvancada}
        listaPessoas={listaPessoas}
        nfsSaida={nfsSaida}
        listaOperacoesFiscaisIniciais={listaOperacoesFiscais}
      />
      <DevolverMercadoriaFornecedorDialog
        openDevolverMercadoriaFornecedorDialog={
          openDevolverMercadoriaFornecedorDialog
        }
        setOpenDevolverMercadoriaFornecedorDialog={
          setOpenDevolverMercadoriaFornecedorDialog
        }
        filtrosDialog={filtrosDialog}
        setFiltrosDialog={setFiltrosDialog}
      />
      <NfeComplementarDialog
        openNfeComplementarDialog={openNfeComplementarDialog}
        setOpenNfeComplementarDialog={setOpenNfeComplementarDialog}
        nfSaida={nfSaida}
        setNfSaida={setNfSaida}
        setLoading={setLoading}
      />
      <InutilizacaoDfeDialog
        openInutilizacaoDfeDialog={openInutilizacaoDfeDialog}
        setOpenInutilizacaoDfeDialog={setOpenInutilizacaoDfeDialog}
        setLoading={setLoading}
      />
      <BaixarXmlDialog
        openBaixarXmlDialog={openBaixarXmlDialog}
        setOpenBaixarXmlDialog={setOpenBaixarXmlDialog}
      />
      <ImportarCondicionalDialog
        openImportarCondicionalDialog={openImportarCondicionalDialog}
        setOpenImportarCondicionalDialog={setOpenImportarCondicionalDialog}
        filtrosDialog={filtrosDialog}
        setFiltrosDialog={setFiltrosDialog}
        listaOperacoesFiscais={listaOperacoesFiscais}
      />
      <NotaDebitoCreditoDialog
        open={openNotaDebitoCreditoDialog}
        setOpen={setOpenNotaDebitoCreditoDialog}
        setLoading={setLoading}
        filtrosDialog={filtrosDialog}
        setFiltrosDialog={setFiltrosDialog}
        listaPessoas={listaPessoas}
        documentoSelectionModel={documentoSelectionModel}
        setDocumentoSelectionModel={setDocumentoSelectionModel}
        listaOperacoesFiscaisIniciais={listaOperacoesFiscais}
      />
    </ListLayout>
  );
};

export default ListNfSaidaView;
